import {RestService} from "@/services/rest/RestService";
import {CodeDescriptionRestDtoModel} from "@/models/CodeDescriptionRestDtoModel";
import {ClientGroupManagementEndpointsApi} from "@/api/pharma-idm-user";

export class ClientGroupManagementService extends RestService {

    private apiService: ClientGroupManagementEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new ClientGroupManagementEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().idmUrl);
    }

    public async findClientGroups(): Promise<CodeDescriptionRestDtoModel[]> {
        const response = await this.apiService.findClientGroupCodes('');

        return response.data;
    }

}
